import { MAINTENANCE_DISABLED } from '@shared/utils/constant'
import { Pages } from '@/types'

export default defineNuxtRouteMiddleware((to) => {
  const $pinia = usePinia()
  const jsonStore = useSharedJsonStore($pinia)

  const isDevMode = to.query?.devMode === 'true'

  const isMaintenanceMode =
    !isDevMode && !MAINTENANCE_DISABLED && jsonStore.isMaintenanceMode

  if (isMaintenanceMode && to.name !== Pages.Maintenance) {
    return navigateTo({ name: Pages.Maintenance })
  }

  if (!isMaintenanceMode && to.name === Pages.Maintenance) {
    return navigateTo({ name: Pages.Index })
  }
})
